import { Component, OnInit, ViewChild, Input, EventEmitter, Output, ChangeDetectorRef, ComponentFactoryResolver, ElementRef } from '@angular/core';
import { FormGroup, NgForm, Validators } from '@angular/forms';
import { CourseModel } from '../model/course-model';
import { CommonHelper } from '../../../../../src/app/core/_config/common.helper';
import { encrypt, decrypt } from '../../../../../src/app/utilities/utilityFunctions';
import { LoaderService } from '../../sharedServices/loader.service';
import { HEC_CONSTANTS } from '../../../../../src/app/utilities/constants';
import { HecResponse } from '../../shared-interfaces/hecResponse';
import { SharedService } from '../../sharedServices/shared.service';
import { IrsipService } from '../../../../../src/app/views/pages/irsip/services/irsip.service';
import { MatSnackBar } from '@angular/material';
import { IrsipDataService } from '../../../../../src/app/views/pages/irsip/services/irsip-data.service';
import { AppFormDataService } from '../../sharedServices/app-form-data.service';
import { environment } from '../../../../../src/environments/environment';

@Component({
	selector: 'kt-course-form',
	templateUrl: './course-form.component.html',
	styleUrls: ['./course-form.component.scss']
})
export class CourseFormComponent implements OnInit {
	public courseForm: FormGroup;
	@Input('formViewType') formViewType: any;
	public course: CourseModel;
	public file: any;
	public qualId: any;
	@ViewChild('ngCourseForm', { static: false }) ngCourseForm: NgForm;
	@Input('courseDetailsData') courseDetailsData: any;
	@Input('dropdownList') dropdownList: any;
	@Input('formType') formType: string;
	@Input('courseDetailGridData') courseDetailGridData;
	@Input('resetForm') resetForm: boolean;
	loader: boolean;
	public isAlertVisible: boolean = false;

	@Output() startDateUpdated = new EventEmitter();
	@Output() endDateUpdated = new EventEmitter();
	@Output() courseUpdated = new EventEmitter();
	@Output() cancelEducation = new EventEmitter();
	alertClass: string;
	alertIcon: string;
	alertMsgValue: any;
	files: any[] = [];
	public eduDropdownLevel: any = { qualificationLevel: [], programTitle: [] };
	private selectedFilePayload: any;
	private attachmentBase64: Blob;
	public isImageAlert: boolean = false;
	private fileExt: string = 'pdf';
	private maxSize: number = 15360;
	public fileUploader: boolean = false;
	public fileName: string = ''

	@ViewChild('fileDropRef', { static: false }) fileDropRef: ElementRef;
	public courseUpload: any;
	@Input('showUploadDocumentPenal') showUploadDocumentPenal: boolean;
	constructor(
		public _snackBar: MatSnackBar,
		private loaderService: LoaderService,
		private sharedServices: SharedService,
		private irsipService: IrsipService,
		public dataService: AppFormDataService,
		private cdr: ChangeDetectorRef) {

	}

	ngOnInit() { }
	ngAfterViewInit(): void { }
	public markFormsTouched(form): void {
		CommonHelper.markFormGroupTouched(form);
	}

	public validate(f): boolean {
		if (f.status === 'VALID') {
			return true;
		}
	}

	public saveCourse() {
		this.markFormsTouched(this.ngCourseForm);
		if (this.validate(this.ngCourseForm)) {
			// if (!this.fileName && this.showUploadDocumentPenal == true) {
			// 	this._snackBar.open('Please upload document.', '', {
			// 		duration: 3500,
			// 		panelClass: ['error-snackbar']
			// 	})
			// 	return false;
			// }
			if(this.ngCourseForm.value.date == null){
				this.ngCourseForm.controls.date.setErrors(Validators.required);
				return false;
			}
			localStorage.setItem('name', encrypt(this.ngCourseForm.value.nameOnDegree))
			let payload = JSON.parse(JSON.stringify(this.ngCourseForm.value))

			if (this.courseDetailsData && this.courseDetailsData.id) {
				payload.id = this.courseDetailsData.id;
				payload = { ...this.courseDetailsData, ...this.ngCourseForm.value }
			}
			payload.irsipApplicationId = this.dataService.applicationId;
			delete payload.nameOnDegree;
			delete payload.searchCtrl;
			this.irsipService.saveOrUpdateCourse(payload).subscribe(
				(res: HecResponse) => {
					if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
						this.isAlertVisible = false;
						let emitData = {
							statusCode: res.statusCode,
							id: res.data.id
						}
						this.courseUpload = res.data;
						// if(this.fileName){
						// 	this.uploadDocuments();
						// }
						// else{
							this.loader = false;
							this.loaderService.setValue(this.loader);
							this.cancelCourse();
						//}
					} else {
						this.loader = false;
						this.loaderService.setValue(this.loader)
						this.isAlertVisible = true;
						this.alertBoxMsg('Error in saving course form');
						this.cdr.detectChanges();
						setTimeout(() => {
							this.isAlertVisible = false;
							this.cdr.detectChanges();
						}, 3000);
					}
				},
				(err) => {
					this.isAlertVisible = true;
					this.alertBoxMsg('Error in saving education form');
					this.loader = false;
					this.loaderService.setValue(this.loader)
					this.cdr.detectChanges();
					setTimeout(() => {
						this.isAlertVisible = false;
						this.cdr.detectChanges();
					}, 3000);
				}
			)
		}
		else {
			if (!this.validate(this.ngCourseForm)) {
				this.alertBoxMsg('Please fill all the mandatory fields with valid data');
				this.isAlertVisible = true;
				this.cdr.detectChanges()
			}
			else if (!this.fileName) {
				this._snackBar.open('Please upload document.', '', {
					duration: 3500,
					panelClass: ['error-snackbar']
				})
				this.alertBoxMsg('Please upload document');
				this.isAlertVisible = true;
				this.cdr.detectChanges()
			}
		}
	}


	private alertBoxMsg(message, alertType?) {
		if (alertType == 'success') {
			this.alertClass = 'alert alert-solid-success alert-bold fade show kt-margin-t-20 kt-margin-b-40';
			this.alertIcon = 'fa fa-check-circle'
		} else if (alertType == 'warning') {
			this.alertClass = 'alert alert-solid-warning alert-bold fade show kt-margin-t-20 kt-margin-b-40';
			this.alertIcon = 'fas fa-exclamation-circle'
		} else {
			this.alertClass = 'alert alert-solid-danger alert-bold fade show kt-margin-t-20 kt-margin-b-40';
			this.alertIcon = 'fa fa-exclamation-triangle'
		}
		this.alertMsgValue = message;
	}


	public findInvalidControls() {
		const invalid = [];
		const controls = this.ngCourseForm.form.controls;
		for (const name in controls) {
			if (controls[name].invalid) {
				invalid.push(name);
			}
		}
		return invalid;
	}

	cancelCourse() {
		this.ngCourseForm.reset();
		this.courseDetailsData = null;
		this.cancelEducation.emit('cancel')
	}
	getSelectedCourseType(e, type) {

	}

	onFileDropped($event) {
		this.prepareFilesList($event);
	}

	/**
	 * handle file from browsing
	 */
	fileBrowseHandler(files) {
		this.prepareFilesList(files);
	}

	/**
	 * Delete file from files list
	 * @param index (File index)
	 */
	deleteFile(index: number) {
		this.files.splice(index, 1);
	}

	/**
	 * Simulate the upload process
	 */
	uploadFilesSimulator(index: number) {
		setTimeout(() => {
			if (index === this.files.length) {
				return;
			} else {
				const progressInterval = setInterval(() => {
					if (this.files[index].progress === 100) {
						clearInterval(progressInterval);
						this.uploadFilesSimulator(index + 1);
						this.fileUploader = false;
						this.cdr.detectChanges();
					} else {
						this.files[index].progress += 5;
					}
				}, 200);
			}
		}, 1000);
	}
	ngOnDestroy(): void {
	}

	/**
	 * Convert Files list to normal array list
	 * @param files (Files List)
	 */
	async prepareFilesList(e: Array<any>) {
		this.files = [];
		this.attachmentBase64 = null;
		if (e.length > 1) return false;
		let file = e[0];
		if (this.isValidFile(file)) {
			this.fileUploader = true;
			this.cdr.detectChanges()
			this.setAttachmentsPayload(file).then(() => {
				for (const item of e) {
					item.progress = 0;
					this.files.push(item);
					this.cdr.detectChanges()
				}
			});

			this.uploadFilesSimulator(0);
		}
		else {
			e = undefined
			file = undefined
			this.fileDropRef.nativeElement.value = null
		}
	}

	private isValidFile(file) {
		const extensions = (this.fileExt.split(',')).map(function (x) { return x.toLocaleLowerCase().trim(); }); // array of extensions
		const ext = file.name.toLowerCase().split('.').pop() || file.name; // file extension
		const fileSizeinKB = file.size / 1024;

		if (extensions.indexOf(ext) === -1) {
			this.isImageAlert = true;
			this._snackBar.open('Error in uploading ' + file.name + ' due to invalid file type.', '', {
				duration: 3500,
				panelClass: ['error-snackbar']
			});
			file = [];
			this.cdr.detectChanges();
			setTimeout(() => {
				this.isImageAlert = false;
				this.cdr.detectChanges();
			}, 3000);
			return false;
		} else if (file.name.match(/^[a-zA-Z-_( ')]*$/)) {
			this.isImageAlert = true;
			file = [];
			this._snackBar.open('Invalid File Name', '', {
				duration: 3500,
				panelClass: ['error-snackbar']
			});
			this.cdr.detectChanges();
			setTimeout(() => {
				this.isImageAlert = false;
				this.cdr.detectChanges();
			}, 3000);
			return false;
		}
		else if (fileSizeinKB > this.maxSize) {
			file = [];
			this.isImageAlert = true
			this._snackBar.open(file.name + ' ( ' + (fileSizeinKB / 1024).toFixed(2) + 'MB )' + ' exceeds file size limit of ' + (this.maxSize / 1024).toFixed(2) + 'MB.', '', {
				duration: 3500,
				panelClass: ['error-snackbar']
			});
			this.cdr.detectChanges();
			setTimeout(() => {
				this.isImageAlert = false;
				this.cdr.detectChanges();
			}, 3000);
			return false;
		}
		return true;
	}

	private async setAttachmentsPayload(file) {
		return await this.convertFileToBase64(file, this).then(res => res);
	}



	private uploadAttachment() {
		//	this.attachmentBase64 = localStorage.getItem('attachmentBase64');
		let payload = {
			data: {
				applicationId: (this.dataService && this.dataService.application &&  this.dataService.application.applicationId) ? this.dataService.application.applicationId : this.dataService.applicationId,
				base64: this.attachmentBase64,
				processAcronym: 'IRSIP',
				subDirectory: "TRANSCRIPT//" + this.courseUpload.id,
				fileName: 'transcript.pdf',
			}
		}
		if (this.attachmentBase64) {
			this.uploadDocumentService(payload)
		}
	}

	// public downloadOrdeleteDocument(row, pageState): void {
	// 	if (row && row.title) {
	// 		let payload = { data: { fileName: this.applicationNumber + '+' + row.title + (row.count != 0 ? '+' + row.count : '') + '.' + row.fileExt, processAcronym: 'RGA', applicationId: this.applicationNumber } }
	// 		if (pageState == 1) {
	// 			this.downloadDocumentFileService(payload, row)

	// 		}
	// 		else if (pageState == 2) {
	// 			this.sharedServices.openCancelConfirmationDialog('CONFIRMATION', 'Are you sure you want to delete the selected document?').then(
	// 				(res) => {
	// 					res ? this.deleteDocumentFileService(payload) : null
	// 				}
	// 			);
	// 		}
	// 		else {

	// 		}
	// 	}
	// 	else {
	// 		this.sharedServices.showError('Document Not Found', 'OK', 'error-snackbar');
	// 	}
	// }

	private async uploadDocumentService(payload) {
		try {
			const res: any = await this.sharedServices.irsipUploadDocument(payload).toPromise();
			if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {

				this.loader = false;
				this.loaderService.setValue(this.loader);
				this.cancelCourse();
				this.saveSucess('Document Uploaded Successfully');
			}
			else {
				this.sharedServices.showError(res.statusDescription, 'OK', 'error-snackbar');
			}
		}
		catch (error) {
			if (error.status == HEC_CONSTANTS.HTTP_RESPONSE.UNAUTHORIZED) {
				this.sharedServices.showError(HEC_CONSTANTS.ERROR_MESSGAES.SOMETHING_WENT_WRONG, 'OK', 'error-snackbar');
			}
		}

	}
	private saveSucess(message) {
		this.loaderService.setValue(false);
		this.cdr.detectChanges();
		this.attachmentBase64 = null;
		this.fileName = null;
		this.sharedServices.showError(message, 'OK', 'success-snackbar');

	}


	private convertFileToBase64(file, _this): any {
		return new Promise((resolve, reject) => {
			CommonHelper.convertFileToBase64(file).then((result) => {
				_this.attachmentBase64 = result;
				_this.fileName = file.name;
				this.cdr.detectChanges()
				resolve(result);
			})
				.catch(function (error) {
					resolve(null);
				})
		})
	}

	formatBytes(bytes, decimals) {
		if (bytes === 0) {
			return '0 Bytes';
		}
		const k = 1024;
		const dm = decimals <= 0 ? 0 : decimals || 2;
		const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
		const i = Math.floor(Math.log(bytes) / Math.log(k));
		return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
	}

	public uploadDocuments() {
		this.loaderService.setValue(true)
		this.uploadAttachment();
	}

	public getCourseType() {
		return (this.dropdownList && this.dropdownList.courseTypes) ? this.dropdownList.courseTypes : []
	}
	public downloadDocument(id,courseName) {
		if (this.dataService && this.dataService.applicationId) {
			this.loaderService.setValue(true);
			this.irsipService.downloadFilesTranscript(this.dataService.applicationId, id).subscribe(res=>{
				let blob = new Blob([res], {type: 'application/pdf'});
				var downloadURL = window.URL.createObjectURL(blob);
				var link = window.document.createElement('a');
				link.href = downloadURL;
				link.download = "Transcript-course-" + courseName;
				link.click();
				this.loaderService.setValue(false);
			},err=>{
				console.debug(err);
				this.loaderService.setValue(false);
			});
		}
	}

	public showUploadDocument() {
		this.showUploadDocumentPenal = !this.showUploadDocumentPenal
	}
}
